/* eslint-disable import/no-default-export */
import React from 'react';

import ArchivedIcon from '../../icons/ArchivedIcon';

import IconBadge from './IconBadge';

const ArchivedBadge = ({ children }) => (
  <IconBadge icon={<ArchivedIcon />}>{children}</IconBadge>
);

export default ArchivedBadge;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/badges/ArchivedBadge.js